function getRequest(urlStr){
	let url =window.location.search;
	let theRequest = new Object();
	if(url.indexOf('?')!=-1){
		let str = url.substr(1);
		let strs = str.split('&');
		for(var i = 0; i< strs.length; i++){
			theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
		}
	}
	return theRequest;
}

export default getRequest;